export default __webpack_public_path__ + "static/media/body-therapy-kit.b89fef29.svg";